import NineSlice from "../NineSlice";
import PopUp from "./PopUp";

export default class PopUpBlue extends PopUp {
    constructor(scene, x, y, width, height) {
        super(scene, x, y);

        this.background = new NineSlice(this.scene, 0, 0, width, height);
        this.add(this.background);
        
        this.Y = - this.background.height / 2 + 15;

    }

    addElementToBody(element, yOffset = 0){
        this.add(element);
        if(element)
        element.y = this.Y + yOffset;
        this.Y += element.height + yOffset;
        
        // if(this.Y > this.background.height - 45 - 80){ // 45 = taille ombre, 80 = marge du bas
        //     console.log("Resize popup", this.Y, this.background.height)
            // this.background.setSize(this.background.width, this.Y + 45 + 80);
        // }
    }

    resize(width, height){
        this.background.setSize(width, height);
    }

    addText(text, textStyle){
        this.textElmt = this.scene.add.text(0, 0, text, textStyle);
        this.textElmt.setOrigin(0.5);
        this.add(this.textElmt);
    }

    animIn(endFunc){
        this.soundManager.playOnce('PopUp')
        super.animIn(endFunc);
    }
}